export default __webpack_public_path__ + "static/82-eb1dd4761e0f2da3e37f5b368db9d925.gif";